export const useStyles = (width: number, selectedWidth: number) => {
  return {
    transition: "transform 200ms ease-in-out, width 200ms ease-in-out",
    width: selectedWidth,
    transform: [
      {
        translateX: width,
      },
    ],
  };
};
